import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-6 text-center">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">404</p>
          <CardTitle className="text-2xl">Page not found</CardTitle>
          <CardDescription>The page you are looking for doesn&apos;t exist.</CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            variant="outline"
            onClick={() => navigate('/repos')}
          >
            <ArrowLeft className="h-4 w-4" />
            Back to repositories
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
